import { useParams } from 'react-router-dom';
import BaseOrientationCheckout from './BaseOrientationCheckout';

const HealthSciOrientationCheckout = () => {
    const { uuid } = useParams<{ uuid: string }>();
    return (
        <BaseOrientationCheckout
            //eventUuid={uuid || ''} //------------------------------------------------------------------ Temporary put back after
            primaryColor="#031586" // Health Sci blue
            secondaryColor="#ffffff" // white
            gradientFrom="from-[#fff]"
            gradientTo="to-[#031586]"
            logoUrl="/branding/orientation/healthsci-logo.png"
            customDateText="September 6 - 13, 2026"
            customLinks={[
                // {
                //     alias: "Health Sciences Resources",
                //     url: "https://www.mcmaster.ca/healthsci/resources"
                // },
                // {
                //     alias: "Program Guide",
                //     url: "https://www.mcmaster.ca/healthsci/program-guide"
                // },
                // {
                //     alias: "Student Services",
                //     url: "https://www.mcmaster.ca/healthsci/student-services"
                // }
            ]}
            customStyles={{
                headerBg: 'bg-[#031586]/10',
                cardBg: 'bg-white/80',
                buttonGradient: 'linear-gradient(to right, #031586, #ffffff)',
                buttonHoverGradient: 'linear-gradient(to right, #031586, #b3c6ff)',
                tagBg: 'bg-[#031586] text-white' // for tags like date, time, location
            }}
            logoSize={240}
            cropLogoToCircle={true}
            eventUuid='b9fd3148-a4ce-4b6f-bf53-8435c965830d' // ---------------------------------------------------------------------------- TEMPORARY
            hidePhoneNumber={true}
            hideTicketsAvailable={true}
        />
    );
};

export default HealthSciOrientationCheckout; 